export * as chat from './chat/Chat.resource';
